import styled from 'styled-components';

import Card from '../../../components/Card/Card';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CardWrapper = styled(Card)`
  max-width: 872px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;

  & div.rt-td, & div.rt-td > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: inherit;
  padding-top: 24px;
  border-top: 1px solid #EEE;
  margin-top: 24px;
  color: #777;
  >h4 {
    font-weight: 400;
    margin: 5px 10px 0px 10px;
  }
  p {
    font-size: 0.9em;
  }
`;
